// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3RvwU","buttons":"SendReceipts_buttons__10hOZ","email":"SendReceipts_email__2g5Qy","bookApptTitle":"SendReceipts_bookApptTitle__svIUR"};